// src/api/categories.api.ts
import api from './Axios';

export const getCategories = () =>
  api.get('/api/categories');

export const getCategoryById = (id: number) =>
  api.get(`/api/categories/${id}`);
